import {mapActions, mapGetters, mapMutations} from "vuex";


export default {
    name: 'thanks',
    data() {
        return {
        }
    },
    methods: {
        ...mapMutations({
            resetBasket: 'order/RESET_BASKET'
        })
    },
    mounted() {
        this.resetBasket();
    },
    created() {
    },
}
